import api from './client';

export const recordsApi = {
  list: (params) => api.get('/records', { params }),
  create: (data) => api.post('/records', data),
  get: (id) => api.get('/records/' + id),
  update: (id, data) => api.put('/records/' + id, data),
  delete: (id) => api.delete('/records/' + id),
  getHistory: (id) => api.get('/records/' + id + '/history'),
  generateReference: (id) => api.post('/records/' + id + '/generate-reference').then(r => r.data),
  getWorkflowsForRecordType: (recordTypeId) => api.get('/records/workflows-for-record-type/' + recordTypeId),
  switchWorkflow: (id, data) => api.post('/records/' + id + '/switch-workflow', data),
  transition: (id, data) => api.post('/records/' + id + '/transition', data),
  logPhiReveal: (id, fieldId, fieldName) => api.post('/records/' + id + '/phi-reveal', { fieldId, fieldName }),

  // Team
  getRecordTeam: (recordId) => api.get('/records/' + recordId + '/team').then(r => r.data),
  assignRecordTeam: (recordId, teamId) => api.patch('/records/' + recordId + '/team', { team_id: teamId }).then(r => r.data),

  // Presence
  heartbeat: (recordId) => api.post('/presence/heartbeat', { record_id: recordId }),
  getPresence: (recordId) => api.get('/presence/' + recordId),
  leavePresence: (recordId) => api.delete('/presence/' + recordId),
};
